import { useState, useEffect } from 'react';
import axios from 'axios';
import { Globals } from './globals';

export function useUserData(user) {
  const [primaryOwnerID1, setPrimaryOwnerID1] = useState('');
  const [primaryOwnerID2, setPrimaryOwnerID2] = useState('');
  const [loading, setLoading] = useState(true);
  const [Admin, setAdmin] = useState('False');

  useEffect(() => {

    let TblID = '';
    let TblIDEmail = '';

    let Season = 'SUMMER';

    if(Season === 'FALL') {
      TblID = '7a0cf73c-9b5f-11ee-b957-eff473c55a31';
      TblIDEmail = '373e86d8-9b86-11ee-966d-53564b4a9738';
    }else {
      TblID = '5838d6e4-9b5f-11ee-b957-93788dc544df';
      TblIDEmail = '48648836-9b86-11ee-966d-b3120495c9ea';
    }    

    const fetchData = async () => {

      try {
        var username = user.username;
        var name = user.attributes.name;
        var useremail = user.attributes.email;

        var url = 'https://g213s33569.execute-api.us-east-2.amazonaws.com/Prod/GetCloudTblData/' + TblIDEmail;

        const response = await axios.get(url);

        let emailToFind = useremail;
        emailToFind = emailToFind.toLowerCase();

        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].Email.toLowerCase() === emailToFind) {
            setPrimaryOwnerID1(response.data[i]['Primary Owner ID (1)']);
            setPrimaryOwnerID2(response.data[i]['Primary Owner ID (2)']);
            setAdmin(response.data[i]['Primary Owner ID (1)']);

            setLoading(false);
            break;
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const ctReadyHandler = function (e) {
      let datasetId = e.datasetId;
      let domId = e.domId;
      let editor = e.editor;
      let table = e.table;

      table.columns().every(function () {
        var column = this;

        // console.log(column.header().textContent)
        if (Admin !== 'Admin') {
          if (column.header().textContent === 'Responsible') {
            column.search(primaryOwnerID1);
          }
        }
      });

    }

    document.addEventListener('ct-ready', ctReadyHandler);
    
    return () => {
      document.removeEventListener('ct-ready', ctReadyHandler);
    }
  }, [primaryOwnerID1, primaryOwnerID2, Admin]);

  useEffect(() => {

    const ctReadyHandler = function (e) {
        let datasetId = e.datasetId;
        let domId = e.domId;
        let editor = e.editor;
        let table = e.table;

        // on table click
        table.on('click', 'tbody td:not(.child, .ct-column__color), dl dt', function (e) {

            table.rows().deselect();
            table.row(this).select();
            editor.inline(this);
        });
    }

    document.addEventListener('ct-ready', ctReadyHandler);

    return () => {
        document.removeEventListener('ct-ready', ctReadyHandler);
    }

}, []);

  return { primaryOwnerID1, primaryOwnerID2, loading, Admin };
}
